<template>
  <div v-cloak v-if="template" class="item-common pt-10 pb-5 px-7">
    <div class="header">
      <h1 class="title">
        {{ $t(template.languageAbilityTitle) }}
        <span v-if="itemMaxLength" class="max-length-guide">
          {{ $t('최대') }} {{ $t(itemMaxLength) }}
          {{ $t(' 개 입력 가능') }}</span
        >
      </h1>
      <v-divider></v-divider>
      <p class="desc" v-html="template.guideLanguageAbility"></p>
    </div>
    <div class="body">
      <v-form ref="saveForm" v-if="!isReadonly">
        <v-row v-if="obj">
          <v-col cols="12" class="col-md-11">
            <v-row>
              <v-col cols="12" class="col-md-3">
                <i-text-field
                  v-maxlength="'language_name'"
                  v-model="obj.languageName"
                  :label="itemLabel('languageName')"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[
                    rules.required('languageName', true),
                    rules.maxlength('languageName'),
                  ]"
                  :class="[zeroRoundedClass]"
                ></i-text-field>
              </v-col>

              <v-col cols="12" class="col-md-3">
                <DirectInputSelect
                  :useDirect="opts.speakingLevel.oDirectInput == 'Y'"
                  v-model="obj.speakingLevel"
                  :items="itemArray('speakingLevel')"
                  :label="itemLabel('speakingLevel')"
                  outlined
                  dense
                  :readonly="isReadonly"
                  v-maxlength="'speakingLevel'"
                  :rules="[rules.required('speakingLevel', true)]"
                />
              </v-col>

              <v-col cols="12" class="col-md-3">
                <DirectInputSelect
                  :useDirect="opts.writingLevel.oDirectInput == 'Y'"
                  v-model="obj.writingLevel"
                  v-maxlength="'writingLevel'"
                  :items="itemArray('writingLevel')"
                  :label="itemLabel('writingLevel')"
                  outlined
                  dense
                  :readonly="isReadonly"
                  :rules="[rules.required('writingLevel', true)]"
                />
              </v-col>

              <v-col cols="12" class="col-md-3">
                <DirectInputSelect
                  :useDirect="opts.readingLevel.oDirectInput == 'Y'"
                  v-model="obj.readingLevel"
                  v-maxlength="'readingLevel'"
                  :items="itemArray('readingLevel')"
                  :label="itemLabel('readingLevel')"
                  outlined
                  dense
                  :readonly="isReadonly"
                  :rules="[rules.required('readingLevel', true)]"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            class="col-md-1 pl-md-3 mb-8 mb-md-0"
            :class="colclass"
          >
            <i-btn elevation="0" color="primary" block @click="add">저장</i-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-alert v-if="submitErrorAlert" dense outlined type="error">
        {{ submitErrorMessage }}
      </v-alert>
      <v-divider v-if="!isReadonly"></v-divider>
      <v-form ref="updateForm">
        <v-row
          v-for="(item, i) in languageAbilityArray"
          :key="'languageabilityrow' + i"
          class="mt-4"
        >
          <v-col cols="12" :class="{ 'col-md-11': !isReadonly }">
            <v-row>
              <v-col cols="12" class="col-md-3">
                <i-text-field
                  v-maxlength="'language_name'"
                  v-model="item.languageName"
                  :label="itemLabel('languageName')"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[
                    rules.required('languageName'),
                    rules.maxlength('languageName'),
                  ]"
                  @blur="save(i)"
                  :class="[zeroRoundedClass]"
                  :readonly="isReadonly"
                ></i-text-field>
              </v-col>
              <v-col cols="12" class="col-md-3">
                <DirectInputSelect
                  :useDirect="opts.speakingLevel.oDirectInput == 'Y'"
                  v-maxlength="'uses_gubun'"
                  v-model="item.speakingLevel"
                  :items="itemArray('speakingLevel')"
                  :label="itemLabel('speakingLevel')"
                  outlined
                  dense
                  @change="save"
                  :readonly="isReadonly"
                  :rules="[rules.required('speakingLevel')]"
                />
              </v-col>

              <v-col cols="12" class="col-md-3">
                <DirectInputSelect
                  :useDirect="opts.writingLevel.oDirectInput == 'Y'"
                  v-maxlength="'writingLevel'"
                  v-model="item.writingLevel"
                  :items="itemArray('writingLevel')"
                  :label="itemLabel('writingLevel')"
                  outlined
                  dense
                  @change="save"
                  :readonly="isReadonly"
                  :rules="[rules.required('writingLevel')]"
                />
              </v-col>
              <v-col cols="12" class="col-md-3">
                <DirectInputSelect
                  :useDirect="opts.readingLevel.oDirectInput == 'Y'"
                  v-maxlength="'readingLevel'"
                  v-model="item.readingLevel"
                  :items="itemArray('readingLevel')"
                  :label="itemLabel('readingLevel')"
                  outlined
                  dense
                  @change="save"
                  :readonly="isReadonly"
                  :rules="[rules.required('readingLevel')]"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            class="col-md-1 pl-md-3 mb-6 mb-md-0"
            :class="colclass"
            v-if="!isReadonly"
          >
            <i-btn
              elevation="0"
              color="normal"
              block
              outlined
              @click="remove(i)"
              >삭제</i-btn
            >
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script>
import { DialogMixin } from '@/mixin/dialog.js';
import DirectInputSelect from '@/components/common/DirectInputSelect.vue';
import { snack } from '@/plugins/dialog/api';
export default {
  components: { DirectInputSelect },
  props: {
    template: { type: Object },
    info: { type: Object },
    opts: { type: Object },
    rules: { type: Object },
    dynamicScreenTagClass: { type: Object },
    leftRoundedClass: { type: Object },
    rightRoundedClass: { type: Object },
    isReadonly: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
  },
  mounted() {
    this.setting();
  },
  computed: {
    itemMaxLength() {
      return +this.opts?.languageAbility?.oMaxLength || 0;
    },
    canAdd() {
      return (
        !this.opts?.languageAbility?.oMaxLength ||
        this.opts.languageAbility?.oMaxLength > this.languageAbilityArray.length
      );
    },
    zeroRoundedClass: function() {
      return {
        'rounded-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
      };
    },
    colclass: function() {
      return {
        'mt-2':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
  },
  mixins: [DialogMixin],
  data: () => ({
    obj: null,
    itemDelimeter: '#',
    languageAbility: '',
    languageAbilityArray: [],
    itemSeq: 1,
    saveAlert: false,
    deleteAlert: false,
    submitErrorAlert: false,
    submitErrorMessage: '',
    isSetWord: false,
  }),
  watch: {
    saveAlert: function() {
      if (this.saveAlert) {
        setTimeout(() => {
          this.saveAlert = false;
        }, 2000);
      }
    },
    deleteAlert: function() {
      if (this.deleteAlert) {
        setTimeout(() => {
          this.deleteAlert = false;
        }, 2000);
      }
    },
    submitErrorAlert: function() {
      if (this.submitErrorAlert) {
        setTimeout(() => {
          this.submitErrorAlert = false;
        }, 10000);
      }
    },
  },
  methods: {
    itemDirectInput: function(key) {
      var direct = 'N';
      if (this.opts && this.opts.hasOwnProperty(key)) {
        direct = this.opts[key].oDirectInput;
      }
      return direct;
    },
    itemArray: function(key) {
      var array = [];
      if (this.opts && this.opts.hasOwnProperty(key)) {
        array = this.opts[key].oItems
          ? this.opts[key].oItems.split(this.itemDelimeter)
          : [];
      }
      return array;
    },
    itemLabel: function(key) {
      var label = this.template[key];
      if (this.opts && this.opts.hasOwnProperty(key)) {
        label =
          this.opts[key].oRequireYn === 'Y'
            ? '*' + this.$t(label)
            : this.$t(label);
      }
      return label;
    },
    setting: function() {
      if (this.template.typeLanguageAbility)
        this.languageAbility = this.template.typeLanguageAbility;
      this.settingData();
      this.obj = this.defaultObj();
    },
    settingData: function() {
      if (
        this.info &&
        this.info.languageAbilitys &&
        this.info.languageAbilitys.length > 0
      ) {
        this.languageAbilityArray = this.info.languageAbilitys.reduce(
          (a, c) => {
            a.push({
              seq: c.id.seq,
              speakingLevel: c.speakingLevel,
              readingLevel: c.readingLevel,
              writingLevel: c.writingLevel,
              languageName: c.languageName,
            });
            return a;
          },
          [],
        );
        this.itemSeq =
          this.languageAbilityArray.reduce((a, c) => {
            a = a > c.seq ? a : c.seq;
          }, this.itemSeq) + 1;
      }
    },
    defaultObj: function() {
      return {
        seq: this.itemSeq++,
        speakingLevel: '',
        readingLevel: '',
        writingLevel: '',
        languageName: '',
      };
    },
    add: function() {
      if (!this.canAdd)
        return this.$showAlert(
          '최대 입력 가능 갯수 : ' + `${this.opts.languageAbility.oMaxLength}`,
        );
      if (this.$refs.saveForm.validate()) {
        this.save(-1);
      }
    },
    remove: function(i) {
      this.delete(i);
    },
    valid: function() {
      //필수 여부 체크
      if (
        this.opts &&
        this.opts.languageAbility &&
        this.opts.languageAbility.oRequireYn &&
        this.opts.languageAbility.oRequireYn == 'Y' &&
        this.languageAbilityArray.length < 1
      ) {
        this.submitErrorMessage = this.$t(
          '최소 1개의 정보는 존재하여야 합니다.',
        );
        this.submitErrorAlert = true;
        return false;
      }

      //컴활 내용을 입력한 것 확인
      if (
        this.obj.languageName &&
        this.obj.languageName != '' &&
        this.languageAbilityArray.length == 0
      ) {
        this.submitErrorMessage = this.$t('저장되지 않은 데이터가 존재합니다.');
        this.submitErrorAlert = true;
        return false;
      } else {
        return this.$refs.updateForm.validate();
      }
    },
    save: function(i) {
      console.log(this.languageAbilityArray);
      console.log(i);
      console.log(this.languageAbilityArray[i]);
      var tmp = i === -1 ? this.obj : this.languageAbilityArray[i];
      if (!this.$refs[i === -1 ? 'saveForm' : 'updateForm'].validate()) return;

      console.log(tmp.seq ?? this.languageAbilityArray.length);

      const id = {
        annoId: this.$route.params.annoId,
        seq: tmp.seq ?? this.languageAbilityArray.length,
      };

      const p = {
        id: id,
        speakingLevel: tmp.speakingLevel,
        writingLevel: tmp.writingLevel,
        readingLevel: tmp.readingLevel,
        languageName: tmp.languageName,
      };

      this.$emit('save', p, 'languageAbility', i);
    },
    savecallback: function(res, i) {
      if (res.status !== 200) {
        console.log('LANGUAGE_ABILITY SAVE FAIL');
      } else {
        snack.info(
          `${this.$t(this.template.languageAbilityTitle)}` +
            this.$t('이 저장 되었습니다.'),
        );
        if (i === -1) {
          this.languageAbilityArray.push(this.obj);
          this.obj = this.defaultObj();
          this.$refs.saveForm.resetValidation();
        }
      }
    },
    delete: function(i) {
      console.log(this.languageAbilityArray);
      console.log(i);
      console.log(this.languageAbilityArray[i]);
      const p = {
        annoId: this.$route.params.annoId,
        seq: this.languageAbilityArray[i].seq,
      };
      this.$emit('delete', p, 'languageAbility', i);
    },
    deletecallback: function(res, i) {
      if (res.status !== 200) {
        console.log('Language_ABILITY DELETE FAIL');
      } else {
        snack.danger(
          `${this.$t(this.template.languageAbilityTitle)}` +
            this.$t('이 삭제 되었습니다.'),
        );
        this.languageAbilityArray.splice(i, 1);
      }
    },
  },
};
</script>

<style>
.v-parallax {
  height: 100% !important;
}
.guide-common {
  min-height: calc(100vh - 64px - 122px);
}

.item-common .header .title {
  font-size: 18px;
  font-weight: bold;
  line-height: 2.67;
  letter-spacing: -0.36px;
  color: #292929;
}
.item-common .header .desc {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.28px;
  color: #555555;
}
.item-common .body {
  margin-top: 22px;
}
.item-common .body .v-divider {
  margin-top: 20px;
  margin-bottom: 20px;
}

.item-common .row {
  margin: 0px;
}
.item-common .col {
  padding: 0px;
}
.item-common .i-text-field {
  min-height: 36px;
}
.btn-post-wrap {
  position: relative;
}
.btn-post {
  position: absolute;
  top: 6px;
  right: 5px;
}
</style>
